import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Offcanvas, CloseButton, Badge, Accordion, Button, Image } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openmenus: []
    }
  }

  openMenu = ( url ) => {
    const { openmenus } = this.state

    if(url in openmenus) {
      let index = openmenus.indexOf(url)
      if (index !== -1) {
        openmenus.splice(index, 1);
      }
    } else {
      openmenus.push( url )
    }

    this.setState({
      openmenus: openmenus
    })
  }

  changeTopSearch = () => {
    this.props.changeLeftMenuh()
    this.props.changeTopSearch()
  }

  render() {

    const { left_menu, changeLeftMenuh, favorite, cart, catalogmenu, page_data, ajax_data } = this.props,
    { openmenus } = this.state

    return (
      <Offcanvas className={styles.left_menu} show={left_menu} onHide={() => changeLeftMenuh()}>
        <Offcanvas.Header className='p-0'>
          <div className={styles.left_menu_top + ` d-flex align-items-center justify-content-between`}>
            <CloseButton className='ms-0' onClick={() => changeLeftMenuh()} />
            <div className='d-flex align-items-center justify-content-end'>
              <a onClick={() => this.changeTopSearch()} className={styles.left_menu_icon}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.75 11.75L17.25 17.25M7.16667 13.5833C3.62284 13.5833 0.75 10.7105 0.75 7.16667C0.75 3.62284 3.62284 0.75 7.16667 0.75C10.7105 0.75 13.5833 3.62284 13.5833 7.16667C13.5833 10.7105 10.7105 13.5833 7.16667 13.5833Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
              {page_data.phone &&
                <a href={`tel:` + page_data.phone.replace(/[-()\s]/g, '')} className={styles.left_menu_icon}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.50246 2.25722C7.19873 1.4979 6.46332 1 5.64551 1H2.89474C1.8483 1 1 1.8481 1 2.89453C1 11.7892 8.21078 19 17.1055 19C18.1519 19 19 18.1516 19 17.1052L19.0005 14.354C19.0005 13.5361 18.5027 12.8009 17.7434 12.4971L15.1069 11.4429C14.4249 11.1701 13.6483 11.2929 13.0839 11.7632L12.4035 12.3307C11.6089 12.9929 10.4396 12.9402 9.7082 12.2088L7.79222 10.2911C7.06079 9.55962 7.00673 8.39134 7.66895 7.59668L8.23633 6.9163C8.70661 6.35195 8.83049 5.57516 8.55766 4.89309L7.50246 2.25722Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              }
              <a href={page_data.favorite_link} className={styles.left_menu_icon + ` position-relative`}>
                <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 4.2002V13.6854C1 15.0464 1 15.7268 1.20412 16.1433C1.58245 16.9151 2.41157 17.3588 3.26367 17.2454C3.7234 17.1842 4.28964 16.8067 5.4221 16.0518L5.42481 16.0499C5.87368 15.7507 6.09815 15.6011 6.33295 15.5181C6.76421 15.3656 7.23476 15.3656 7.66602 15.5181C7.90129 15.6012 8.12664 15.7515 8.57732 16.0519C9.70978 16.8069 10.2767 17.1841 10.7364 17.2452C11.5885 17.3586 12.4176 16.9151 12.7959 16.1433C13 15.7269 13 15.0462 13 13.6854V4.19691C13 3.07899 13 2.5192 12.7822 2.0918C12.5905 1.71547 12.2837 1.40973 11.9074 1.21799C11.4796 1 10.9203 1 9.8002 1H4.2002C3.08009 1 2.51962 1 2.0918 1.21799C1.71547 1.40973 1.40973 1.71547 1.21799 2.0918C1 2.51962 1 3.08009 1 4.2002Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {favorite.length > 0 &&
                  <Badge className={styles.firstng_badge + ` position-absolute top-0 start-100 translate-middle`} pill bg="danger">{favorite.length}</Badge>
                }
              </a>
              <a href={page_data.cart_link} className={styles.left_menu_icon + ` position-relative`}>
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.7083 15.7083C14.5577 15.7083 13.625 16.6411 13.625 17.7917C13.625 18.9423 14.5577 19.875 15.7083 19.875C16.8589 19.875 17.7917 18.9423 17.7917 17.7917C17.7917 16.6411 16.8589 15.7083 15.7083 15.7083ZM15.7083 15.7083H7.68119C7.20092 15.7083 6.96034 15.7083 6.76261 15.6229C6.58818 15.5475 6.43686 15.4262 6.3266 15.2714C6.20302 15.0979 6.15332 14.866 6.05494 14.4068L3.49113 2.44234C3.39046 1.97254 3.33945 1.73789 3.21444 1.56242C3.10418 1.40766 2.95288 1.28585 2.77845 1.21047C2.58068 1.125 2.34145 1.125 1.86097 1.125H1.125M4.25 4.25H17.6596C18.4115 4.25 18.787 4.25 19.0393 4.40662C19.2604 4.54382 19.4222 4.75898 19.4928 5.00938C19.5733 5.29524 19.4698 5.65621 19.2614 6.3786L17.8191 11.3786C17.6945 11.8105 17.6322 12.0261 17.5058 12.1863C17.3942 12.3278 17.2471 12.4385 17.0803 12.5065C16.8918 12.5833 16.6678 12.5833 16.2209 12.5833H6.05257M6.33333 19.875C5.18274 19.875 4.25 18.9423 4.25 17.7917C4.25 16.6411 5.18274 15.7083 6.33333 15.7083C7.48393 15.7083 8.41667 16.6411 8.41667 17.7917C8.41667 18.9423 7.48393 19.875 6.33333 19.875Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {cart.length > 0 &&
                  <Badge className={styles.firstng_badge + ` position-absolute top-0 start-100 translate-middle`} pill bg="danger">{cart.length}</Badge>
                }
              </a>
              <a href={page_data.kabinet_link} className={styles.left_menu_icon}>
                <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5 17.5835C13.5 15.1903 10.5899 13.2502 7 13.2502C3.41015 13.2502 0.5 15.1903 0.5 17.5835M7 10.0002C4.60677 10.0002 2.66667 8.06006 2.66667 5.66683C2.66667 3.2736 4.60677 1.3335 7 1.3335C9.39323 1.3335 11.3333 3.2736 11.3333 5.66683C11.3333 8.06006 9.39323 10.0002 7 10.0002Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className={styles.left_menu_body}>
          <div className={styles.left_menu_menus}>
            <div className={styles.left_menu_menu}>
              <div className={styles.left_menu_menu_el}>
                <a href={page_data.new_link}>Новые поступления</a>
                <div className={styles.left_menu_menu_el_new}></div>
              </div>
              <Accordion flush className={styles.left_menu_menu_accordion}>
                {catalogmenu.map((elm, k) => {
                  return (
                    <>
                      {elm.child != null ?
                        (
                          <Accordion.Item eventKey={k} className={styles.left_menu_menu_accordion_el}>
                            <Accordion.Header className={styles.left_menu_menu_el}>
                              {/*<a href={elm.url}>{elm.name}</a>*/}
                              <span>{elm.name}</span>
                            </Accordion.Header>
                            <Accordion.Body className={styles.left_menu_menu_el_body}>
                              {elm.child.map((celm, j) => {
                                return (
                                  <>
                                    <div key={j} className={styles.left_menu_menu_el_2}>
                                      {celm.child.length > 0 ?
                                        <>
                                          {openmenus.includes(celm.url) ?
                                            <a className={styles.left_menu_menu_el_2_cntnr_open} href={celm.url}>{celm.name}</a>
                                          :
                                            <div className={styles.left_menu_menu_el_2_cntnr} onClick={() => this.openMenu( celm.url )}>{celm.name}</div>
                                          }
                                        </>
                                      :
                                        <a href={celm.url}>{celm.name}</a>
                                      }
                                    </div>
                                    {celm.child.length > 0 &&
                                      <div className={openmenus.includes(celm.url) ? styles.left_menu_menu_el_2_cmenu_open : styles.left_menu_menu_el_2_cmenu}>
                                        {celm.child.map((ccelm, i) => {
                                          return (
                                            <>
                                              <div key={i} className={styles.left_menu_menu_el_3}>
                                                <a href={ccelm.url}>{ccelm.name}</a>
                                              </div>
                                            </>
                                          )
                                        })}
                                      </div>
                                    }
                                  </>
                                )
                              })}
                            </Accordion.Body>
                          </Accordion.Item>
                        ) : (
                          <div className={styles.left_menu_menu_el}>
                            <a style={{ 'color': '#da0000' }} href={elm.url}>{elm.name}</a>
                          </div>
                        )
                      }
                    </>
                  )
                })}
              </Accordion>
              <div className={styles.left_menu_menu_el}>
                <a href={page_data.poshiv_link}>Индивидуальный пошив</a>
              </div>
              <div className={styles.left_menu_menu_el}>
                <a href={page_data.karti_link}>Подарочные карты</a>
              </div>
            </div>
            <div className={styles.left_menu_menu}>
              <Accordion flush className={styles.left_menu_menu_accordion}>
                {page_data.informacziya.length > 0 &&
                  <Accordion.Item eventKey="0" className={styles.left_menu_menu_accordion_el}>
                    <Accordion.Header className={styles.left_menu_menu_el}>Информация</Accordion.Header>
                    <Accordion.Body className={styles.left_menu_menu_el_body}>
                      {page_data.informacziya.map((elm, k) => {
                        return (
                          <div key={k} className={styles.left_menu_menu_el_2}>
                            <a href={elm.url}>{elm.name}</a>
                          </div>
                        )
                      })}
                    </Accordion.Body>
                  </Accordion.Item>
                }
                {page_data.pokupatelyam.length > 0 &&
                  <Accordion.Item eventKey="1" className={styles.left_menu_menu_accordion_el}>
                    <Accordion.Header className={styles.left_menu_menu_el}>Покупателям</Accordion.Header>
                    <Accordion.Body className={styles.left_menu_menu_el_body}>
                      {page_data.pokupatelyam.map((elm, k) => {
                        return (
                          <div key={k} className={styles.left_menu_menu_el_2}>
                            <a href={elm.url}>{elm.name}</a>
                          </div>
                        )
                      })}
                    </Accordion.Body>
                  </Accordion.Item>
                }
              </Accordion>
            </div>
            <div className={styles.left_menu_menu}>
              <Accordion className={styles.left_menu_menu_accordion}>
                <Accordion.Item eventKey="0" className={styles.left_menu_menu_accordion_el}>
                  <Accordion.Header className={styles.left_menu_menu_el}>Филиалы</Accordion.Header>
                  <Accordion.Body className={styles.left_menu_menu_el_body}>
                    {page_data.shops_menu.map((elm, k) => {
                      return (
                        <div key={k} className={styles.left_menu_menu_el_2}>
                          <div>
                            <b>{elm.name}</b><br />
                            {elm.adres}<br />
                            <span style={{ fontSize: `12px`, color: '#8a8a8a'}}>{`Режим работы: ` + elm.worktime}</span></div>
                        </div>
                      )
                    })}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            {'new_ng' in ajax_data &&
              <>
                {ajax_data.new_ng.length > 0 &&
                  <div className={styles.left_menu_menu}>
                    <div className='mb-4 d-flex align-itms-center justify-content-start'>
                      {ajax_data.new_ng.map(( elm, i ) => {
                        if( elm.href != '' ) return (
                          <a href={elm.href} target="_blank" key={i} className={styles.newng_story}>
                            <div className={styles.newng_story_image}>
                              <Image src={elm.photo} width={71} height={71} alt="story" />
                            </div>
                            <div className={styles.newng_story_name}>{elm.title}</div>
                          </a>
                        )
                        return (
                          <div key={i} className={styles.newng_story}>
                            <div className={styles.newng_story_image}>
                              <Image src={elm.photo} width={71} height={71} alt="story" />
                            </div>
                            <div className={styles.newng_story_name}>{elm.title}</div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                }
              </>
            }
          </div>
          <div className={styles.left_menu_btm}>
            <div className={styles.left_menu_text_title}>Связаться с нами</div>
            {page_data.phone &&
              <div className={styles.left_menu_text}>
                <a href={`tel:` + page_data.phone.replace(/[-()\s]/g, '')}>{page_data.phone}</a>
              </div>
            }
            {page_data.tg &&
              <Button href={page_data.tg} className={styles.left_menu_tg} variant='dark'>
                <div>Телеграм</div>
                <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.817444 5.85442C0.817444 5.85442 6.71446 3.23916 8.75964 2.31826C9.54366 1.94994 12.2024 0.771182 12.2024 0.771182C12.2024 0.771182 13.4296 0.255522 13.3273 1.50789C13.2932 2.0236 13.0205 3.82849 12.7478 5.78076C12.3387 8.5434 11.8956 11.5638 11.8956 11.5638C11.8956 11.5638 11.8275 12.4111 11.248 12.5584C10.6685 12.7057 9.71406 12.0428 9.54366 11.8954C9.40727 11.7849 6.98714 10.1273 6.10089 9.31692C5.86227 9.09592 5.58959 8.65393 6.13495 8.13821C7.36209 6.92265 8.82781 5.41243 9.71406 4.45472C10.1231 4.01268 10.5321 2.98131 8.82781 4.23368C6.40767 6.03861 4.0216 7.73303 4.0216 7.73303C4.0216 7.73303 3.4762 8.10135 2.45361 7.76983C1.43097 7.43836 0.237932 6.99632 0.237932 6.99632C0.237932 6.99632 -0.580102 6.4438 0.817444 5.85442Z" fill="white"/>
                </svg>
              </Button>
            }
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    )
  }
}

Main.propTypes = {
  left_menu: PropTypes.bool,
  changeLeftMenuh: PropTypes.func,
  changeTopSearch: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  catalogmenu: PropTypes.array,
  page_data: PropTypes.object,
  ajax_data: PropTypes.object
}